export type BoosterPackType = "starter" | "study_session" | "power_pack" | "weekly_pass";

export interface BoosterPackConfig {
    stars_price: number;
    text_credits?: number;
    voice_credits: number;
    duration_days?: number;
    enabled: boolean;
}

export interface BoosterPacks {
    starter: BoosterPackConfig;
    study_session: BoosterPackConfig;
    power_pack: BoosterPackConfig;
    weekly_pass: BoosterPackConfig;
}

export const DEFAULT_BOOSTER_PACKS: BoosterPacks = {
    starter: { stars_price: 100, text_credits: 50, voice_credits: 5, enabled: true },
    study_session: { stars_price: 250, text_credits: 200, voice_credits: 25, enabled: true },
    power_pack: { stars_price: 500, text_credits: 600, voice_credits: 80, enabled: true },
    weekly_pass: { stars_price: 625, voice_credits: 125, duration_days: 7, enabled: true },
};
